import type { RichtextAdapterProps } from "modules/storyblok/adapters/RichtextAdapter";

const textStyles: RichtextAdapterProps["customStyles"] = {
  paragraph: {
    fontSize: "lg",
    maxW: { base: "100vw", lg: "55vw", xl: "46vw" },
    textAlign: { base: "left", lg: "center" },
    lineHeight: "tall",
    mb: 14,
  },
};

const linkStyles: RichtextAdapterProps["customStyles"] = {
  link: { fontSize: "lg", fontWeight: "normal", _visited: {} },
};

export { textStyles, linkStyles };
